import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';
import type {Values} from '@wix/devzai-utils-common';
import {doppeValidateTwitterUrl} from '@wix/devzai-utils-common';


export const TwitterWidgetTheme = {
    Light: 'light',
    Dark: 'dark',
} as const;

export namespace DoppeActionTypeTwitterEmbed {

    export type Theme = Values<typeof TwitterWidgetTheme>;

    export interface ActionSettings {
        twitterUrl: string;
        theme: Theme;
    }
}

export const doppeActionTypeTwitterEmbed = doppeActionTypeDefineMetadata<DoppeActionTypeTwitterEmbed.ActionSettings>({
    id: 'io.bymo.action/twitter-embed',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        twitterUrl: '',
        theme: TwitterWidgetTheme.Light,
    }),
    hasNoGoalMeasuring: false,
    hasNoLockInnerCTA: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            twitterUrl: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl, {
                description: 'urlFormat.twitter',
                aiValidator: (value) => {
                    if (typeof value !== 'string') {
                        return `Expected a URL string, got ${typeof value}`;
                    }
                    if (!doppeValidateTwitterUrl(value)) {
                        return `Must be an X (Twitter) URL on x.com or twitter.com`;
                    }
                    return null;
                },
            })
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
})

